// extracted by mini-css-extract-plugin
module.exports = {"solution-box-row":"VShDx","solutionBoxRow":"VShDx"};